<svg [attr.class]="'unity-icon-' + icon + ' ' + size + ' ' + color">
    <use [attr.xlink:href]="'#unity-icon-' + icon"></use>
</svg>